import { Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import { FC, useEffect, useState } from 'react';
import { s3FileApi } from 'src/api/s3file';
import { FileModel } from 'src/interfaces/new-channel-partner/channelPartner';

interface ImageDialogProps{
  open: boolean;
  onClose: () => void;
  imagePath: string;
  docName: string;
  docNumber: string;
  file: FileModel;
}

export const ImageDialogBox: FC<ImageDialogProps> = (props) => {
  const { imagePath, open, docNumber, docName, file, onClose, ...other } = props;
  const [url, setUrl] = useState(''); // eslint-disable-line

  const getUrl = async () => {
    if (file.type === 'application/pdf') {
      const docUrl = await s3FileApi.getDocumentFile(imagePath);
      setUrl(docUrl);
    } else {
      const imageUrl = await s3FileApi.getImageFile(imagePath);
      setUrl(imageUrl);
    }
  };
  const onCloseDialog = (e, reason) => {
    if (reason !== 'backdropClick') {
      URL.revokeObjectURL(url);
      setUrl('');
      onClose();
    }
  };

  const renderDeiailsItem = (label, value) => (
    <>
      <Typography
        sx={{ mr: 1 }}
        display="inline-block"
        align="center"
      >
        {label}
      </Typography>
      <Typography
        color="GrayText"
        display="inline-block"
        align="center"
      >
        {value}
      </Typography>
    </>
  );

  useEffect(() => {
    if (open) {
      getUrl().catch(console.error);
    }
  }, [imagePath, file]);

  return (
    <>
      { url && (
      <Dialog
        maxWidth="lg"
        onClose={onCloseDialog}
        open={open}
        {...other}
      >
        <DialogTitle
          sx={{ justifyContent: 'flex-end' }}
        >
          <Grid
            container
            xs={12}
            md={12}
          >
            <Grid
              item
              xs={12}
              md={6}
            >
              {docName ? renderDeiailsItem('Document Name: ', docName) : ''}
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              {docNumber ? renderDeiailsItem('Document Number: ', docNumber) : ''}
            </Grid>
          </Grid>
          <IconButton
            sx={{
              position: 'absolute',
              right: 8,
              top: 8
            }}
            color="inherit"
            onClick={(e) => onCloseDialog(e, '')}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent
          sx={{ justifyItems: 'center' }}
        >
          <embed
            style={{ objectFit: 'scale-down' }}
            type={file.type}
            src={url}
            height="500px"
            width="700px"
          />
        </DialogContent>
      </Dialog>
      )}
    </>
  );
};

ImageDialogBox.defaultProps = {
  open: false,
  imagePath: undefined
};

ImageDialogBox.propTypes = {
  // @ts-ignore
  open: PropTypes.bool,
  onClose: PropTypes.func,
  imagePath: PropTypes.string,
  docName: PropTypes.string,
  docNumber: PropTypes.string,
  // @ts-ignore
  file: PropTypes.object
};
